import type { AppProps } from 'next/app'
import '../index.css'
import CartDrawer from '../cart/CartDrawer'
import { CartProvider } from '../cart'
import { CustomerAuthProvider } from '../customer-auth'
import { ShopI18nProvider, type ShopLocale } from '../i18n'
import { ThemeProvider } from '../theme'

function ShopAppRoot({ Component, pageProps }: AppProps) {
  const initialLocale =
    (pageProps as { initialLocale?: ShopLocale } | undefined)?.initialLocale
  const initialActiveLocales =
    (pageProps as { initialActiveLocales?: ShopLocale[] } | undefined)?.initialActiveLocales

  return (
    <ThemeProvider>
      <CustomerAuthProvider>
        <ShopI18nProvider initialLocale={initialLocale} availableLocales={initialActiveLocales}>
          <CartProvider>
            <main id="main-content">
              <Component {...pageProps} />
            </main>
            <CartDrawer />
          </CartProvider>
        </ShopI18nProvider>
      </CustomerAuthProvider>
    </ThemeProvider>
  )
}

export default ShopAppRoot
